import { format, parseISO } from "date-fns";

export const formatDate = (date: string) => {
  if (!date) return "";

  try {
    const dateObject = parseISO(date);
    const formattedDate = format(dateObject, "yyyy-MM-dd");
    return formattedDate;
  } catch (error) {
    console.error("Invalid date format:", date, error);
    return "";
  }
};

export const formattedDate = (date?: string) => {
  if (!date) return "Invalid date";
  try {
    const parsedDate = parseISO(date);
    return format(parsedDate, "d MMM, yyyy");
  } catch (error) {
    return "Invalid date";
  }
};

export function formatDateTime(inputDateTime: string): string {
  if (!inputDateTime) return "";

  const months: string[] = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  // Use parseISO to avoid JS Date fallback to "now" on undefined
  // and to consistently parse ISO strings without timezone surprises
  let date: Date;
  try {
    date = parseISO(inputDateTime);
  } catch (_err) {
    return "";
  }

  if (isNaN(date.getTime())) {
    // Invalid date string – return empty to avoid showing current time
    return "";
  }

  const day: number = date.getDate();
  const month: string = months[date.getMonth()];
  const year: number = date.getFullYear();

  const hours24: number = date.getHours();
  const hours12: number = hours24 % 12 || 12;
  const minutes: number = date.getMinutes();
  const ampm: string = hours24 < 12 ? "am" : "pm";

  const formattedDate: string = `${day}${getOrdinalSuffix(
    day
  )} ${month} ${year}, ${hours12}:${padZero(minutes)}${ampm}`;

  return formattedDate;
}

function getOrdinalSuffix(day: number): string {
  if (day >= 11 && day <= 13) {
    return "th";
  }
  const lastDigit: number = day % 10;
  switch (lastDigit) {
    case 1:
      return "st";
    case 2:
      return "nd";
    case 3:
      return "rd";
    default:
      return "th";
  }
}

// Helper function to pad single-digit minutes with a leading zero
function padZero(value: number): string {
  return value < 10 ? "0" + value : value.toString();
}

export function formatMonthYear(inputDateTime: string): string {
  const months: string[] = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const date: Date = new Date(inputDateTime);

  const month: string = months[date.getMonth()]?.toUpperCase();
  const year: number = date.getFullYear();

  const formattedDate: string = `${month} ${year}`;

  return formattedDate;
}

export function formatDateYear(inputDateTime: string): string {
  if (!inputDateTime) return "";
  const months: string[] = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const date: Date = new Date(inputDateTime);

  const day: number = date.getDate();
  const month: string = months[date.getMonth()];
  const year: number = date.getFullYear();

  const formattedDate: string = `${day}${getOrdinalSuffix(
    day
  )} ${month} ${year}`;

  return formattedDate;
}

export function dateDifferenceInWords(targetDatetime: Date): string {
  var currentDatetime = new Date();
  var difference = currentDatetime.getTime() - targetDatetime.getTime();

  var millisecondsInDay = 1000 * 60 * 60 * 24;
  var days = Math.floor(difference / millisecondsInDay);
  var weeks = Math.floor(days / 7);
  var months =
    currentDatetime.getMonth() -
    targetDatetime.getMonth() +
    (currentDatetime.getFullYear() - targetDatetime.getFullYear()) * 12;
  var years = currentDatetime.getFullYear() - targetDatetime.getFullYear();

  if (years > 0) {
    return years + " " + (years === 1 ? "year" : "years");
  } else if (months > 0) {
    return months + " " + (months === 1 ? "month" : "months");
  } else if (weeks > 0) {
    return weeks + " " + (weeks === 1 ? "week" : "weeks");
  } else {
    return days + " " + (days === 1 ? "day" : "days");
  }
}
